/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.event__accept-button[_ngcontent-%COMP%]{margin-right:5px}.event__username[_ngcontent-%COMP%]{font-weight:700;color:#7cd5ba}.event__avatar[_ngcontent-%COMP%]{width:30px;height:30px;border-radius:50%;display:inline-block;margin-right:5px;-webkit-box-shadow:0 0 0 5px #4c5d67;box-shadow:0 0 0 5px #4c5d67}.event__picture[_ngcontent-%COMP%]{width:100%}.event__detail[_ngcontent-%COMP%]{font-size:.8em}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2lkZW5hdi90aW1lbGluZS9zaWRlbmF2LXRpbWVsaW5lLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2lkZW5hdi90aW1lbGluZS9zaWRlbmF2LXRpbWVsaW5lLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/sidenav/timeline/sidenav-timeline.component.scss.shim.ngstyle.ts